import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Suppress react-quill findDOMNode warning (known issue, doesn't affect functionality)
const originalError = console.error;
console.error = (...args) => {
    if (args[0]?.includes?.('findDOMNode is deprecated')) {
        return;
    }
    originalError.call(console, ...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
